import e from"styled-components";const i=e.div`
	position: absolute;
	display: grid;
	place-content: center;
	height: 100vh;
	width: 100%;
	padding: 1rem;
	background: ${({theme:e})=>"light"===e.name?"rgba(0, 0, 0, 0.15)":"rgba(255, 255, 255, 0.05)"};
	box-sizing: border-box;
	border: none;
	z-index: 10;
`,o=e.div`
	width: 1080px;
	height: 640px;
	background-color: ${({theme:e})=>e.bg.general};
	border-radius: 12px;
	display: flex;
	flex-direction: column;
	z-index: 20;
`,r=e.header`
	padding: 24px 32px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: ${({justifyContent:e="space-between"})=>e};
	gap: 8px;
	border-bottom: ${({hasBorder:e=!1})=>e?"1px solid rgba(0, 0, 0, 0.15)":"none"};
`,t=e.h1`
	font-family: "PP Formula";
	font-size: 16px;
	color: ${({theme:e})=>e.text.text};
	font-weight: 400;
`,d=e.div`
	display: flex;
	align-items: center;
	gap: 16px;
`,n=e.input`
	width: 340px;
	padding: 4px 8px;
	border-radius: 8px;
	border: none;
	color: ${({theme:e})=>e.text.input};
	background-color: ${({theme:e})=>e.bg.primary};
	height: 34px;
	font-size: 14px;
	outline: none;
`,p=e.button`
	display: grid;
	place-content: center;
	width: 24px;
	height: 24px;
	font-size: 18px;
	font-weight: 400;
	background: none;
	border: none;
	cursor: pointer;
	margin-top: -4px;
	color: ${({theme:e})=>e.text.title};
`,a=e.div`
	padding: 32px;
	display: flex;
	flex-direction: column;
	gap: 40px;
	overflow: hidden;
	position: relative;
`,l=e.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 24px;
`,x=e.div`
	display: flex;
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.1);
	overflow: hidden;
	box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
	cursor: pointer;
`,s=e.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	overflow: hidden;
`,c=e.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	overflow: auto;
`,g=e.div`
	width: 140px;
	height: 105px;
	background-image: url(${({backgroundImage:e})=>e});
	background-size: cover;
`,f=e.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	flex: 1;
	padding-inline: 24px;
`,b=e.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`,u=e.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`,h=e.h1`
	margin: 0;
	font-size: 14px;
	color: ${({theme:e})=>e.text.text};
`,m=e.p`
	margin: 0;
	color: rgba(0, 0, 0, 0.5);
	font-size: 13px;
`,v=e.div`
	display: flex;
	gap: 8px;
`,y=e.span`
	padding: 5px 8px;
	display: grid;
	place-content: center;
	text-transform: uppercase;
	border-radius: 9999px;
	font-size: 10px;
	border: 1px solid ${({theme:e})=>e.text.title};
	color: ${({isActive:e,theme:i})=>e?`${i.bg.general}`:`${i.text.title}`};
	background-color: ${({isActive:e,theme:i})=>e?`${i.text.title}`:`${i.bg.general}`};
	cursor: pointer;
	user-select: none;
`,w=e.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,$=e.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`,z=e.h1`
	margin: 0;
	font-size: 16px;
	font-weight: 700;
	color: ${({theme:e})=>e.text.text};
`,k=e.div`
	display: flex;
	align-items: center;
	gap: 4px;
	color: #fff;
	background-color: #00afff;
	font-size: 14px;
	font-weight: 400;
	cursor: pointer;
	padding: 4px 12px;
	border-radius: 9999px;
`,j=e.div`
	transform: rotate(180deg);
	padding-top: 2.5px;
`,A=e.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
`,P=e.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	cursor: pointer;
	position: relative;
	border-radius: 4px;

	& > div {
		border: 1px solid #eaeaea;
	}

	&:hover {
		& > div {
			display: grid;
			background-color: rgba(0, 0, 0, 0.3);
		}
	}
`;e.div`
	background-color: rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	min-height: 126px;
`,e.span`
	color: ${({theme:e})=>e.text.text};
	font-size: 12px;
`;const B=e.div`
	padding: 32px;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	overflow: auto;
`,C=e.div`
	cursor: pointer;
	min-height: 177.034px;
	overflow: hidden;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0px;
	border: 1px solid ${({theme:e})=>e.border.black10};
	background-color: ${({theme:e})=>e.bg.primary};
	border-radius: 4px;

	&:hover {
		& > div {
			display: grid;
			background-color: rgba(0, 0, 0, 0.3);
		}
	}
`,F=e.div`
	display: none;
	place-content: center;
	inset: 0;
	position: absolute;
	z-index: 20;
`,I=e.button`
	padding: 8px 16px;
	color: #fafafa;
	border-radius: 9999px;
	font-size: 12px;
	background-color: #00afff;
	z-index: 20;
	border: none;
	cursor: pointer;
`,q=e.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	padding: 32px;
	overflow: hidden;
`,D=e.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	overflow: hidden;
	position: relative;

	& > div:last-child {
		height: 55px;
	}

	&:hover {
		& > div {
			display: grid;
			background-color: rgba(0, 0, 0, 0.3);
			border-radius: 4px;
		}
	}
`,E=e.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`,G=e.span`
	color: #3b3b3b;
	font-size: 16px;
	font-weight: 400;
`;export{j as ButtonIconContainer,b as CardContent,f as CardContentContainer,g as CardCover,u as CardHeader,h as CardHeading,m as CardParagraph,d as DialogActionsContainer,p as DialogBackButton,x as DialogCardContainer,l as DialogCardsContainer,c as DialogCategories,s as DialogCategoriesContainer,i as DialogContainer,o as DialogContentContainer,r as DialogHeaderContainer,t as DialogHeading,n as DialogSearchInput,a as DialogSectionContainer,w as GroupContainer,k as GroupContainerButton,$ as GroupContainerHeader,z as GroupContainerHeading,A as GroupSubcategoriesContainer,I as GroupTemplateButton,F as GroupTemplateButtonContainer,P as SubgroupContainer,y as Tab,v as TabsContainer,D as TemplateBlockSet,E as TemplateBlockSetContainer,G as TemplateBlockSetName,q as TemplateBlocksSetsContainer,B as TemplatesContainer,C as TemplatesGroupPreviewContainer};
